import classNames, { Argument as ClassNameArgument } from "classnames";
import React, { CSSProperties, FC } from "react";
import { styles } from "./box.scss";


export const Box: FC<{
    fit?: true | "none" | "width" | "height" | "both";
    center?: boolean;
    middle?: boolean;
    pad?: boolean | number | [number, number?];
    noWrap?: boolean;
    className?: ClassNameArgument;
    style?: CSSProperties;
    children?: React.ReactNode;
    onClick?: () => any;
}> =
    ({ fit, center, middle, pad, noWrap, className, style, children, onClick }) =>
    {
        fit =
            (fit === true)
                ? "both"
                : fit ?? "none";

        const padding =
            (pad === true) && { padding: "1em" } ||
            (typeof pad == "number") && { padding: `${pad}em` } ||
            (Array.isArray(pad)) && { padding: pad.map(p => `${p}em`).join(" ") };

        style =
        {
            ...padding,
            ...style,
        };

        return (
            <div
                className={
                    classNames(
                        styles.box,
                        (fit != "none") && styles[`fit-${fit}`],
                        center && styles.center,
                        middle && styles.middle,
                        noWrap && styles.noWrap,
                        className,
                    )}
                style={style}
                onClick={onClick}
            >
                {children}
            </div>
        );
    };
